/** Is this the public demo build?
 *
 *  Lives in its own module so that lease.ts, identity.ts and flightTrack.ts can
 *  ask without importing auth.tsx, which imports lease.ts — that cycle is how
 *  you get an undefined at module-init time.
 *
 *  Set by `export VITE_DEMO=1` at build time. See portal/deploy-demo.sh. */
export function demoEnabled(): boolean {
  if (import.meta.env.DEV) return true;
  return import.meta.env.VITE_DEMO === '1';
}
